import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrandColorsModalComponent} from './brand-colors-modal.component';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [BrandColorsModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    ButtonModule
  ],
  exports: [BrandColorsModalComponent]
})
export class BrandColorsModalModule {
}
